import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.getToken();

  if (req.url.includes('/api/login') || req.url.includes('/api/public')) {
    return next(req);
  }

  if (token) {
    if (!authService.isTokenExpired()) {
      const clonedRequest = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`)
      });

      return next(clonedRequest);
    } else {
      authService.needsLogout.set(true);
    }
  }

  return next(req);
};
